<template>
  <div 
    v-if="url"
    style="width:1080px;height:980px;background-size:cover;"
    :style="{ 'background-image': `url(${url})` }"
  >
  </div>
</template>
<script>
import { mapState } from 'vuex'
import utils from '@/services/utils'
export default {
  data: () => ({
    url: null,
  }),
  computed: {
    ...mapState('app',['locale', 'totemActiveMenu', 'totemItemImageTranslate']),
  },
  watch: {
    locale () {
      this.prepareImage()
    },
    totemItemImageTranslate () {
      this.prepareImage()
    },
  },
  mounted () {
    this.prepareImage()
  },
  methods: {
    prepareImage () {
      this.url = null
      if (!this.totemItemImageTranslate) return
      this.url = utils.getTranslation(this.totemItemImageTranslate, this.locale)
    }
  }
}
</script>
<style scope>
</style>

